import { Center, Input, Select, Stack } from '@chakra-ui/react';
import { useState } from 'react';
import { Subtipo_inmueble, Tipologia_inmueble } from '../../data/constants';

const FiltroInmuebles = ({ setFiltros }) => {
	const [tipologia, setTipologia] = useState('');
	const [subtipologia, setSubtipologia] = useState('');

	const subtiposDisponibles =
		Subtipo_inmueble.find(item => item.tipo === tipologia)?.subtipo || [];

	const handleTipologiaChange = e => {
		const selectedTipologia = e.target.value;
		setTipologia(selectedTipologia);
		setSubtipologia(''); // reset subtipologia al cambiar la tipologia
		setFiltros(e); // actualiza el filtro padre
	};

	const handleSubtipologiaChange = e => {
		setSubtipologia(e.target.value);
		setFiltros(e);
	};

	return (
		<Center>
			<Stack direction='column' spacing={0} align='center'>
				<Input
					rounded='none'
					placeholder='Buscar'
					name='busqueda'
					onChange={setFiltros}
				/>

				<Stack direction='row' spacing={4} align='center'>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Estado --'
							onChange={setFiltros}
							name='estado'
						>
							<option value='Inmueble'>Inmueble</option>
							<option value='Noticia'>Noticia</option>
							<option value='Encargo'>Encargo</option>
						</Select>
					</Stack>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Tipología --'
							name='tipologiaInmueble'
							value={tipologia}
							onChange={handleTipologiaChange}
						>
							{Tipologia_inmueble.map((tipo, index) => {
								return (
									<option key={index} value={tipo.tipo}>
										{tipo.tipo}
									</option>
								);
							})}
						</Select>
					</Stack>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Subtipología --'
							name='subtipologiaInmueble'
							value={subtipologia}
							onChange={handleSubtipologiaChange}
						>
							{subtiposDisponibles.map((tipo, index) => {
								return (
									<option key={index} value={tipo.tipo}>
										{tipo.tipo}
									</option>
								);
							})}
						</Select>
					</Stack>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Creación --'
							name='orden'
							onChange={setFiltros}
						>
							<option value='asc'>Antiguas primero</option>
							<option value='desc'>Recientes primero</option>
						</Select>
					</Stack>
				</Stack>
			</Stack>
		</Center>
	);
};

export default FiltroInmuebles;
